module.exports = __webpack_public_path__ + "img/user.abfe4e1d.png";